module.exports = __webpack_public_path__ + "img/upgrade.18d9add9.svg";